import React from 'react';
import { Button, ButtonGroup } from '@mui/material';
import { Add } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

import { BaseLoadProfileDto, LoadProfileDto, HeatPumpLoadProfileDto, LoadProfileType } from '../../pv-calculator.dto';
import HeatPumpLoad from './HeatPumpLoad';
import CustomLoad from './CustomLoad';
import BaseLoad from './BaseLoad';

export default function LoadProfilesContainer(props: {
    value: LoadProfileDto[];
    onChange: (loadProfiles: LoadProfileDto[]) => void;
}) {
    const { t } = useTranslation();

    const addLoadProfile = (type: LoadProfileType) => {
        let newProfile: LoadProfileDto;
        switch (type) {
            case LoadProfileType.BASE:
                newProfile = {
                    type,
                } as BaseLoadProfileDto;
                break;
            case LoadProfileType.HEAT_PUMP:
                newProfile = {
                    type,
                    annual_heat_demand: 0,
                    annual_cop: 0,
                } as HeatPumpLoadProfileDto;
                break;
            case LoadProfileType.CUSTOM:
                newProfile = {
                    type,
                    values: [],
                };
                break;
        }

        props.onChange([...props.value, newProfile]);
    };
    const deleteLoadProfile = (i: number) => {
        const newLoadProfiles = [...props.value];
        newLoadProfiles.splice(i, 1);
        props.onChange(newLoadProfiles);
    };
    const updateLoadProfile = (i: number, newProfile: LoadProfileDto) => {
        const newLoadProfiles = [...props.value];
        newLoadProfiles[i] = newProfile;
        props.onChange(newLoadProfiles);
    };

    return (
        <>
            <ButtonGroup color="primary" size="small">
                <Button startIcon={<Add />} onClick={() => addLoadProfile(LoadProfileType.BASE)}>
                    {t('Base usage')}
                </Button>
                <Button startIcon={<Add />} onClick={() => addLoadProfile(LoadProfileType.HEAT_PUMP)}>
                    {t('Heat pump')}
                </Button>
                <Button startIcon={<Add />} onClick={() => addLoadProfile(LoadProfileType.CUSTOM)}>
                    {t('From CSV')}
                </Button>
            </ButtonGroup>

            {props.value.map((loadProfile, i) => (
                <React.Fragment key={i}>
                    {loadProfile.type === LoadProfileType.BASE && (
                        <BaseLoad
                            value={loadProfile}
                            onChange={(changedProfile) => updateLoadProfile(i, changedProfile)}
                            onDelete={() => deleteLoadProfile(i)}
                        />
                    )}

                    {loadProfile.type === LoadProfileType.HEAT_PUMP && (
                        <HeatPumpLoad
                            value={loadProfile}
                            onChange={(changedProfile) => updateLoadProfile(i, changedProfile)}
                            onDelete={() => deleteLoadProfile(i)}
                        />
                    )}

                    {loadProfile.type === LoadProfileType.CUSTOM && (
                        <CustomLoad
                            value={loadProfile}
                            onChange={(changedProfile) => updateLoadProfile(i, changedProfile)}
                            onDelete={() => deleteLoadProfile(i)}
                        />
                    )}
                </React.Fragment>
            ))}
        </>
    );
}
